// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrap":"material-tabs__wrap--2noaM","tab":"material-tabs__tab--2QPh2","active":"material-tabs__active--Ecsmx"};